import React from 'react';
import { cn } from '../../../../../utils/tailwind';
import { IconCheck } from '../../../../app/icons/check';

type TariffFeaturesCheckType = {
    forPartners?: boolean;
};

export const TariffFeaturesCheck: React.FC<TariffFeaturesCheckType> = ({ forPartners = false }) => {
    return (
        <div
            className={cn(
                'flex items-center justify-center rounded-[5rem] bg-[var(--tariff-color-light)] text-[var(--tariff-color)] [&_i]:h-[1.2rem] [&_i]:w-[1.2rem]',
                forPartners ? 'h-medium w-medium [&_i]:h-[1.8rem] [&_i]:w-[1.8rem]' : 'h-[2.4rem] w-[2.4rem]',
            )}
        >
            <IconCheck />
        </div>
    );
};
